export default __webpack_public_path__ + "static/media/pro-elevate-pyl-1.ed54ec70.png";